import {
  Button as ThemeUIButton,
  ButtonProps as ThemeUIButtonProps,
  Spinner,
} from 'theme-ui'

type ButtonProps = ThemeUIButtonProps & {
  caption?: string
  sx?: BaseStyleObject
  isLoading?: boolean
  buttonStyle?: string
  unstyled?: boolean
  disabled?: boolean
  ref?: React.RefObject<HTMLButtonElement>
}

const defaultStyles = {
  border: 'transparent',
  color: 'primaryText',
  fontSize: 2,
  fontWeight: 'buttons',
  lineHeight: 1,
  cursor: 'pointer',
  px: '32px',
  py: '16px',
}

const Button = ({
  disabled,
  buttonStyle,
  unstyled = false,
  variant,
  caption,
  isLoading,
  sx,
  ...props
}: ButtonProps) => {
  const resolvedVariant = unstyled
    ? 'buttons.unstyled'
    : buttonStyle
      ? `buttons.${buttonStyle}`
      : variant

  return (
    <ThemeUIButton
      {...props}
      variant={resolvedVariant}
      sx={{
        ...(!unstyled && defaultStyles),
        ...(disabled && { background: 'gray' }),
        ...sx,
      }}
    >
      {caption}
      {isLoading && <Spinner data-cy="button-loading" />}
    </ThemeUIButton>
  )
}

export default Button
